// extracted by mini-css-extract-plugin
export default {"page":"build_page_page__jeliZ","content":"build_page_content__sr8IP"};